import setSyncRequestOperation from 'owa-service/lib/operation/setSyncRequestOperation';
import SetSyncRequestRequest from 'owa-service/lib/contract/SetSyncRequestRequest';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import SetSyncRequestData from 'owa-service/lib/contract/SetSyncRequestData';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function setSyncRequest(
    syncRequest: SetSyncRequestData
): Promise<OptionsResponseBase> {
    let request: SetSyncRequestRequest = {
        Header: getJsonRequestHeader(),
        SyncRequest: syncRequest,
    };

    let response: OptionsResponseBase = await setSyncRequestOperation(request);
    return response;
}
